/* eslint-disable no-unused-vars */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState, useMemo, useEffect } from "react";
import { Nav, Tab, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import SVG from "react-inlinesvg";
import objectPath from "object-path";
import { Link } from "react-router-dom";
import { useSelector, useDispatch, shallowEqual } from 'react-redux';

import { useHtmlClassService } from "../../../_metronic/layout/_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { DropdownTopbarItemToggler } from "../../../_metronic/_partials/dropdowns";
import { fetchNotificationyAsync } from './_redux/notificattion.api'

const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false, 
};
const ENDPOINT = `${process.env.REACT_APP_HOST}:${process.env.REACT_APP_PORT}`;

export function UserNotificationsDropdown() {

  const dispatch = useDispatch();
  
  const  { notificationList, notificationBatch, notificationLimit }  = useSelector(state => state.notification)
  const  { user }  = useSelector(state => state.auth, shallowEqual)
  
  const btnClickFetchData = () => {
    
  }

  const [key, setKey] = useState("Alerts");
  const bgImage = toAbsoluteUrl("/media/misc/bg-1.jpg");
  const [notificationArry, setNotificationArry] = useState([])
  const [active, setActive] = useState(false);
  useEffect(() => {
    dispatch(fetchNotificationyAsync( 0, 10 ))

  }, []);

  useEffect(() => {

    let newNotification = notificationList && notificationList.records ? notificationList.records.find(noti => !noti.isRead) : null;
    if(newNotification){
      console.log(newNotification)
      setActive(true);
    }

  }, [notificationList]);

  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, "extras.notifications.layout") ===
        "offcanvas",
    };
  }, [uiService]);

  return (
    <>
      {layoutProps.offcanvas && (
        <div className="topbar-item">
          <div
            className="btn btn-icon btn-clean btn-lg mr-1 pulse pulse-primary "
            id="kt_quick_notifications_toggle"
          >
            <span className="svg-icon svg-icon-xl svg-icon-primary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Compiling.svg")} />
            </span>
            <span className="pulse-ring"></span>
          </div>
        </div>
      )}
      {!layoutProps.offcanvas && (
        <Dropdown drop="down" alignRight onClick={() => btnClickFetchData()}>
          <Dropdown.Toggle
            as={DropdownTopbarItemToggler}
            id="kt_quick_notifications_toggle"
          >
            
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="user-notification-tooltip" >
                  User Notifications
                </Tooltip>
              }
              
            >
              <div
                className="btn btn-icon btn-clean btn-lg mr-5 pulse pulse-primary lblue_v2 usrntfctn rounded-circle"
                id="kt_quick_notifications_toggle"
              >
                { active ? <div className="ntfctn_dott"></div>: null}
                <span className="svg-icon svg-icon-xl svg-icon-primary">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/Notifications1.svg")}
                  />
                </span>
                <span className="pulse-ring"></span>
                <span className="pulse-ring" />
              </div>
            </OverlayTrigger>
          </Dropdown.Toggle>

          <Dropdown.Menu className="dropdown-menu p-5 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg ntfctnsdrpdwn pl-0">
            <form>
              {/** Head */}
              <div className="d-flex flex-column rounded-top">
                <div className="d-flex justify-content-between pt-3 pb-7">
                  <div className="fn_s_18 f-w-700 color_blk">Notifications</div>
                  <Link 
                    to="/notifications" 
                    className="xs_btn"
                  >
                    View All
                  </Link>
                </div>
                <PerfectScrollbar
                className="scroll px-3"
                options={ perfectScrollbarOptions }
                style={{ maxHeight: "350px", position: "relative" }}                  
              >
                
                { notificationList.records.map((item, i) => {
                if(i < 5) {
                  return (
                <div className="ap_new d-flex align-items-center mb-6">
                  <div className="symbol symbol-50 symbol-light-primary ap_rounded_12">
                    { !item.isRead ? <div className="ntfctn_dott"></div>: null}
                    <img alt="user" src={item.profilePicture} className="h-50px w-50px rounded-circle"/>
                  </div>
                  <div className="pl-5 ap_notification_text d-flex flex-column">
                    <a href="/notifications" className="ap_ellips fn_s_16 f-w-500 color_blk mb-0">
                    <span className="ap_ellips fn_s_14 f-w-400 color_blk opacity50">
                      {item.message}
                    </span>
                      {/* {item.categoryType} */}
                    </a>
                  </div>
            </div>
                  )
                }
                return null;
            }
            )}
              </PerfectScrollbar>
                
              </div>
            </form>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
}
